import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SolutionsNavigation.css';

const SolutionsNavigation = ({ prevTitle, prevLink, nextTitle, nextLink }) => {
    const navigate = useNavigate();

    return (
        <section className="solutions-navigation">
            <div className="solutions-nav-container">
                {prevTitle && prevLink ? (
                    <button className="solutions-nav-prev" onClick={() => navigate(prevLink)}>
                        <div className="solutions-nav-icon-black">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M19 12H5M12 19l-7-7 7-7"/>
                            </svg>
                        </div>
                        <span className="solutions-nav-title">{prevTitle}</span>
                    </button>
                ) : (
                    <div className="solutions-nav-placeholder"></div>
                )}

                {nextTitle && nextLink ? (
                    <button className="solutions-nav-next" onClick={() => navigate(nextLink)}>
                        <span className="solutions-nav-title">{nextTitle}</span>
                        <div className="solutions-nav-icon-orange">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                        </div>
                    </button>
                ) : (
                    <div className="solutions-nav-placeholder"></div>
                )}
            </div>
        </section>
    );
};

export default SolutionsNavigation;
